<template>
  <div class="main">
    <el-row :gutter="20">
      <div v-for="(item,index) in newsContent" :key="index" @click="contentPage(item.id)">
        <el-col :span="6">
          <div class="grid-content bg-purple img-list-bg">
            <div class="img-bg">
              <img :src="item.thumbnail"/>
            </div>
            <p>{{item.title}}</p>
          </div>
        </el-col>
      </div>
    </el-row>
    <!--分页-->
    <el-pagination
      background
      layout="prev, pager, next"
      :total="totalElements"
      :page-count="totalPages"
      id="pagination"
      :current-page="number"
      :page-sizes="[5, 10, 20, 40]"
      :page-size="size"
      @current-change="handleCurrentChange"
    >
    </el-pagination>

  </div>

</template>

<script>
  import axios from '@/axios'

  export default {
    name: "imgList",
    data() {
      return {
        totalPages: 0,//总页数
        totalElements: 0, //总条数
        size: 0, //当前页条数
        number: 1, //当前页从1开始
        newsContent: [],
        newsLength: '',
        url: 'picture'
      }
    },
    components: {},
    created: function () {
      this.getImgList();
    },
    methods: {
      //当前页  currentPage 改变时会触发
      handleCurrentChange: function (currentPage) {
        this.number = currentPage;
        // this.getNewsList(currentPage);
      },

      getImgList(currentPage = 1) {
        let _this = this;
        //获取新闻列表片数据
        axios.get(this.$store.state.apiBasePath + "/" + this.url + "/list?page=" + currentPage)
          .then(function (res) {
            if (res.data.code == 200) {
              let resData = res.data.data;
              _this.newsContent = resData.content;
              _this.newsLength = resData.content.length;

              _this.totalPages = resData.totalPages;
              _this.totalElements = resData.totalElements;
              _this.number = resData.number + 1; //服务器返回数据从0开始，分页组件从1开始，所以要加1
              _this.size = resData.size;
              // console.log(resData)
            }

          })
      },


      contentPage(id) {
        this.$router.push("/contentPage/"+id)
      },

    }
  }
</script>

<style scoped>
  .main {
    width: 1170px;
    margin: auto auto 15px auto;
  }

  .img-list-bg {
    background: #fff;
    border-radius: 5px;
    border: #ddd 1px solid;
    box-shadow: #ddd 0 0 5px;
    margin: 15px 0;
    overflow: hidden;
  }

  .img-list-bg:hover {
    cursor: pointer;
    color: #379ce9;
  }

  .img-bg {
    overflow: hidden;
    padding: 5px 5px;
  }

  .img-list-bg img {
    width: 100%;
    height: 200px;
    display: block;
    transition: all 0.5s;
    -webkit-transition: all .5s; /* Safari 和 Chrome */
    -ms-transition: all .5s; /* IE 9 */
    -moz-transition: all .5s; /* Firefox */
    --o-transition: all .5s; /* Opera */

  }

  .img-list-bg img:hover {
    cursor: pointer;
    opacity: 0.8;
    transform: scale(1.3);
    -ms-transform: scale(1.3); /* IE 9 */
    -moz-transform: scale(1.3); /* Firefox */
    -webkit-transform: scale(1.3); /* Safari 和 Chrome */
    -o-transform: scale(1.3); /* Opera */
  }

  .img-list-bg p {
    margin: 10px 10px;
    overflow: hidden;
    display: block;
    height: 26px;
    line-height: 26px
  }


</style>



// WEBPACK FOOTER //
// src/components/imgList.vue